import axios from "axios";
import { useState, useContext } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { date } from "yup/lib/locale";
import { LoginContext } from "./../Context/LoginContext";
import { IUser, UserContextType } from "./../Context/UserTypes";
import configData from "./../Auth/configData.json";
import { isTokenExpired } from "../components/Common/tokenExpiration";
import CustomErrorMessage from "./CustomErrorMessage";
import BsAlert from "../components/Controles/BsAlert";

/////////////////////////////////////////////////////////////////////////////////////////////

//export default function AuthUser () {
//    const navigate = useNavigate();

//    const getToken = () =>{
//        const tokenString = sessionStorage.getItem('token');
//        const userToken = JSON.parse(tokenString || '{}');
//        return userToken;
//    }

//    const getUser = () =>{
//        const userString = sessionStorage.getItem('user');
//        const user_detail = JSON.parse(userString || '{}');
//        return user_detail;
//    }

//    const [token,setToken] = useState(getToken());
//    const [user,setUser] = useState(getUser());

//    const saveToken = (user,token) =>{
//        sessionStorage.setItem('token',JSON.stringify(token));
//        sessionStorage.setItem('user',JSON.stringify(user));

//        setToken(token);
//        setUser(user);
//        navigate('/dashboard');
//    }

//    const logout = () => {
//        sessionStorage.clear();
//        navigate('/login');
//    }

//    const http = axios.create({
//        baseURL:"https://localhost:44334/api",
//        headers:{
//            "Content-type" : "application/json",
//            "Authorization" : `Bearer ${token}`
//        }
//    });
//    return {
//        setToken:saveToken,
//        token,
//        user,
//        getToken,
//        http,
//        logout
//    }
//}

/////////////////////////////////////////////////////////////////////////////////////////////////////

///////// The Abouve commented code will be used if session storage is used for context
////////  storage will be used below code.

export default function AuthUser() {
  const navigate = useNavigate();
  const { saveUser, logoutUser } = useContext(LoginContext) as UserContextType;
  const { users } = useContext(LoginContext) as UserContextType;

  const getloginInfo = () => {
    //const User: IUser = {
    //    token: users.token,
    //    userID: users.userID,
    //    userType: users.userType,
    //    IsAuthenticated: users.IsAuthenticated,
    //    userTypeID: users.userTypeID,
    //    email: users.email,
    //    dateCreated: users.dateCreated,
    //    name: users.name,
    //}

    const User: IUser = {
      token: "",
      userID: 0,
      userType: "",
      IsAuthenticated: false,
      userTypeID: 0,
      email: "",
      dateCreated: "",
      name: "",
    };
    var retrievedObject = JSON.parse(localStorage.getItem("loggedInUserObj"));
    if (retrievedObject == null) {
      return User;
    } else {
      return retrievedObject;
    }

    //return User
  };

  const getUser = () => {
    const userString = sessionStorage.getItem("user");
    const user_detail = JSON.parse(userString || "{}");
    return user_detail;
  };

  const [user, setUser] = useState(getloginInfo());
  const saveToken = (data: IUser) => {
    const user: IUser = {
      token: data.token,
      userID: data.userID,
      userType: data.userType,
      IsAuthenticated: data.IsAuthenticated,
      userTypeID: data.userTypeID,
      email: data.email,
      dateCreated: data.dateCreated,
      name: data.name,
    };
    localStorage.setItem("loggedInUserObj", JSON.stringify(user));
    //saveUser(user);
    //setUser(user);
    //navigate('/main');
  };

  const logout = () => {
    const user: IUser = {
      token: null,
      userID: null,
      userType: null,
      IsAuthenticated: false,
      userTypeID: null,
      email: null,
      dateCreated: null,
      name: null,
    };

    localStorage.removeItem("loggedInUserObj");
    saveUser(user);
    setUser(user);
    //logoutUser();
    //alert(user);
    //navigate('/login');
  };
  const http = axios.create({
    baseURL: window.env.REACT_APP_API_URL,
  });

  http.interceptors.request.use(
    (config) => {
      // Check if the token is present and not expired
      const fullPageUrl = window.location.href;
      // Add the fullPageUrl as a parameter to the request
      config.params = {
        ...config.params,
        fullPageUrl: fullPageUrl,
      };
      config.headers["Authorization"] = `Bearer ${
        user == null ? "" : user.token
      }`;
      //config.headers["Content-type"] = "application/json";
      config.headers["Content-type"] = "application/json";

      //   if (!isTokenExpired()) {
      //     config.headers["Authorization"] = `Bearer ${
      //       user == null ? "" : user.token
      //     }`;
      //     config.headers["Content-type"] = "application/json";
      //     // config.headers["Access-Control-Allow-Origin"] = "*";
      //     // config.headers["Access-Control-Allow-Headers"] = "*";
      //     // config.headers["Access-Control-Allow-Methods"] = "*";
      //   } else {
      //     // Handle token expiration, e.g., by refreshing the token or redirecting to login
      //     // You can also redirect the user to the login page here
      //     // history.push('/login');
      //     console.log(
      //       "Token has expired. You should refresh or re-authenticate."
      //     );
      //   }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  http.interceptors.response.use(
    (response) => {
      //console.log(JSON.stringify(response));
      return response;
    },
    (error) => {
      if (isTokenExpired()) navigate("/TokenExpired");
      else {
        const errorText = error.message;
        //navigate("/ServerError/Test");
        //navigate("/ServerError/" + errorText);
      }
      // Handle errors, including unauthorized errors
      if (error.response && error.response.status === 401) {
        navigate("/login");
        console.log("Unauthorized request. Token may be expired.");
        // You can also redirect the user to the login page here
        // history.push('/login');
      }
      return Promise.reject(error);
    }
  );

  const httpform = axios.create({
    baseURL: window.env.REACT_APP_API_URL,
  });

  httpform.interceptors.request.use(
    (config) => {
      // Check if the token is present and not expired
      const fullPageUrl = window.location.href;
      // Add the fullPageUrl as a parameter to the request
      config.params = {
        ...config.params,
        fullPageUrl: fullPageUrl,
      };
      config.headers["Authorization"] = `Bearer ${
        user == null ? "" : user.token
      }`;
      //config.headers["Content-type"] = "application/json";
      config.headers["Content-type"] = "multipart/form-data";

      //   if (!isTokenExpired()) {
      //     config.headers["Authorization"] = `Bearer ${
      //       user == null ? "" : user.token
      //     }`;
      //     config.headers["Content-type"] = "application/json";
      //     // config.headers["Access-Control-Allow-Origin"] = "*";
      //     // config.headers["Access-Control-Allow-Headers"] = "*";
      //     // config.headers["Access-Control-Allow-Methods"] = "*";
      //   } else {
      //     // Handle token expiration, e.g., by refreshing the token or redirecting to login
      //     // You can also redirect the user to the login page here
      //     // history.push('/login');
      //     console.log(
      //       "Token has expired. You should refresh or re-authenticate."
      //     );
      //   }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  httpform.interceptors.response.use(
    (response) => {
      //console.log(JSON.stringify(response));
      return response;
    },
    (error) => {
      if (isTokenExpired()) navigate("/TokenExpired");
      else {
        const errorText = error.message;
        //navigate("/ServerError/Test");
        navigate("/ServerError/" + errorText);
      }
      // Handle errors, including unauthorized errors
      if (error.response && error.response.status === 401) {
        navigate("/ServerError/You are not authorized user.");
        console.log("Unauthorized request. Token may be expired.");
        // You can also redirect the user to the login page here
        // history.push('/login');
      }
      return Promise.reject(error);
    }
  );

  const httpold = axios.create({
    baseURL:
      configData.IsLiveSite == "0"
        ? configData.LocalSERVER_URL
        : configData.LiveSERVER_URL,
    //baseURL: "https://remody-com-v2.azurewebsites.net/api",
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${user == null ? "" : user.token}`,
    },
  });

  const httpformold = axios.create({
    baseURL:
      configData.IsLiveSite == "0"
        ? configData.LocalSERVER_URL
        : configData.LiveSERVER_URL,
    //baseURL: "https://remody-com-v2.azurewebsites.net/api",
    headers: {
      "Content-Type": "multipart/form-data",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${user == null ? "" : user.token}`,
    },
  });
  const httpblob = axios.create({
    baseURL: window.env.REACT_APP_API_URL,
    //baseURL: "https://remody-com-v2.azurewebsites.net/api",
    headers: {
      Authorization: `Bearer ${user == null ? "" : user.token}`,
    },
    responseType: "blob",
  });
  return {
    setToken: saveToken,
    user,
    http,
    logout,
    getloginInfo,
    httpform,
    httpblob,
  };
}
